import { render } from "./DetalharCentroDeCusto.vue?vue&type=template&id=02b04de8&scoped=true"
import script from "./DetalharCentroDeCusto.vue?vue&type=script&lang=js"
export * from "./DetalharCentroDeCusto.vue?vue&type=script&lang=js"

import "./DetalharCentroDeCusto.vue?vue&type=style&index=0&id=02b04de8&scoped=true&lang=css"
import "./DetalharCentroDeCusto.vue?vue&type=style&index=1&id=02b04de8&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b04de8"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInput,QBtn,QLinearProgress,QRadio,QTable,QImg,QTd,QField});
